export var AlertVariants;

(function (AlertVariants) {
  AlertVariants["INFORMATIONAL"] = "INFORMATIONAL";
  AlertVariants["SUCCESS"] = "SUCCESS";
  AlertVariants["WARNING"] = "WARNING";
  AlertVariants["CRITICAL"] = "CRITICAL";
})(AlertVariants || (AlertVariants = {}));